import { memo, useCallback } from 'react';
import { useTranslation } from '@betty/i18n';
import { Icon, PressableOverlay, Text } from '@betty/moonlight';
import { OtherAmountProps } from './OtherAmount.types';
import { formatAmount } from '@betty/toolkit/utils';
import AmountContainer from '../AmountContainer/AmountContainer';

function OtherAmount({
  amount,
  disabled,
  selected,
  onPress,
}: OtherAmountProps) {
  const { t } = useTranslation('wallet');

  const handlePress = useCallback(() => {
    onPress(selected ? amount : undefined);
  }, [amount, selected, onPress]);

  return (
    <AmountContainer
      flexDirection="row"
      gap="space-100"
      opacity={disabled ? 0.5 : undefined}
      selected={selected}
    >
      {selected && (
        <Icon
          name="edit"
          width="space-400"
          height="space-400"
          color="iconPrimary"
        />
      )}
      <Text
        variant="h6"
        {...(selected
          ? { color: 'accentSurfacePrimary' }
          : { gradient: 'darkSurfaceAccent' })}
      >
        {selected && amount !== undefined
          ? formatAmount(amount)
          : t('depositOtherAmount')}
      </Text>
      <PressableOverlay onPress={disabled ? undefined : handlePress} />
    </AmountContainer>
  );
}

export default memo(OtherAmount);
